module.exports = __webpack_public_path__ + "img/in-logo.892ca5c9.svg";